import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, useApiMutation} from '../../../hooks/api/api';
import {
  GenerateMarketReport,
  GetMarketReports,
  GetMarketReport,
} from '../../../shared/api/definitions/debug';
import {TaskStatusQueryKeys} from '../../../hooks/api/tasks';

export function useGenerateMarketReport() {
  const queryClient = useQueryClient();
  return useApiMutation(GenerateMarketReport, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TaskStatusQueryKeys.task('generateMarketReport'),
      });
    },
  });
}

export const MarketReportQueryKeys = {
  all: ['marketReports'] as const,
  market: (marketId: string) =>
    [...MarketReportQueryKeys.all, 'list', marketId] as const,
};

export const useGetMarketReports = createApiQuery(
  GetMarketReports,
  ({marketId}) => MarketReportQueryKeys.market(marketId.toString())
);

export const useGetMarketReport = createApiQuery(
  GetMarketReport,
  ({reportId}) => [...MarketReportQueryKeys.all, 'report', reportId.toString()]
);
